<template>
  <div class="modal-body">
    <div class="container">
      <div class="gridPhoto">
        <div class="card border-success mb-4 shadow-lg">
          <!--  -->
          <div class="image-preview" v-if="imageData[0] != undefined">
            <img
              class="container"
              :src="`${imageData[0]}`"
              @click="clickPreview(imageData[0])"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <!--  -->

          <div class="card-body column">
            <p class="card-text">Foto Plaqueta de Identificação do molde</p>
            <div class="icons" v-if="configInputs == 0">
              <div v-if="configInputs == 0" class="btn-group">
                <label
                  class="palavra"
                  for="FotoPlaquetadeIdentificacaodomoldePreview"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  @change="previewFiles($event, 0)"
                  id="FotoPlaquetadeIdentificacaodomoldePreview"
                />

                <label
                  class="palavra"
                  @click="resetFile(0)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-success mb-4 shadow-lg">
          <!--  -->
          <div class="image-preview" v-if="imageData[1] != undefined">
            <img
              class="container"
              :src="`${imageData[1]}`"
              @click="clickPreview(imageData[1])"
              width="195"
              height="210"
              border="0"
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <!--  -->

          <div class="card-body column">
            <p class="card-text">ID da Câmara Quente</p>
            <div class="icons">
              <div v-if="configInputs == 0" class="btn-group">
                <label class="palavra" for="IDdaCâmaraQuentePreview"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  @change="previewFiles($event, 1)"
                  id="IDdaCâmaraQuentePreview"
                />

                <label
                  class="palavra"
                  @click="resetFile(1)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-success mb-4 shadow-lg">
          <!--  -->
          <div class="image-preview" v-if="imageData[2] != undefined">
            <img
              class="container"
              :src="`${imageData[2]}`"
              @click="clickPreview(imageData[2])"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <!--  -->

          <div class="card-body column">
            <p class="card-text">Foto do Lado Direito</p>
            <div class="icons">
              <div v-if="configInputs == 0" class="btn-group">
                <label class="palavra" for="FotodoLadoDireitoPreview"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  @change="previewFiles($event, 2)"
                  id="FotodoLadoDireitoPreview"
                />

                <label
                  class="palavra"
                  @click="resetFile(2)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>
        <div class="card border-success mb-4 shadow-lg">
          <!--  -->
          <div class="image-preview" v-if="imageData[3] != undefined">
            <img
              class="container"
              :src="`${imageData[3]}`"
              @click="clickPreview(imageData[3])"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <!--  -->

          <div class="card-body column">
            <p class="card-text">Foto do Lado Esquerdo</p>
            <div class="icons">
              <div v-if="configInputs == 0" class="btn-group">
                <label class="palavra" for="FotodoLadoEsquerdoPreview"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  @change="previewFiles($event, 3)"
                  id="FotodoLadoEsquerdoPreview"
                />

                <label
                  class="palavra"
                  @click="resetFile(3)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-success mb-4 shadow-lg">
          <!--  -->
          <div class="image-preview" v-if="imageData[4] != undefined">
            <img
              class="container"
              :src="`${imageData[4]}`"
              @click="clickPreview(imageData[4])"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <!--  -->

          <div class="card-body column">
            <p class="card-text">Foto da Placa do Lado Móvel</p>
            <div class="icons">
              <div v-if="configInputs == 0" class="btn-group">
                <label class="palavra" for="FotodaPlacadoLadoMovelPreview"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  @change="previewFiles($event, 4)"
                  id="FotodaPlacadoLadoMovelPreview"
                />

                <label
                  class="palavra"
                  @click="resetFile(4)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-success mb-4 shadow-lg">
          <!--  -->
          <div class="image-preview" v-if="imageData[5] != undefined">
            <img
              class="container"
              :src="`${imageData[5]}`"
              @click="clickPreview(imageData[5])"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <!--  -->

          <div class="card-body column">
            <p class="card-text">Foto da Placa do Lado Fixo</p>
            <div class="icons">
              <div v-if="configInputs == 0" class="btn-group">
                <label class="palavra" for="FotodaPlacadoLadoFixoPreview"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  @change="previewFiles($event, 5)"
                  id="FotodaPlacadoLadoFixoPreview"
                />

                <label
                  class="palavra"
                  @click="resetFile(5)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>
        <div class="card border-success mb-4 shadow-lg">
          <!--  -->
          <div class="image-preview" v-if="imageData[6] != undefined">
            <img
              class="container"
              :src="`${imageData[6]}`"
              @click="clickPreview(imageData[6])"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="card-body column">
            <p class="card-text">Foto do Lado Superior</p>
            <div class="icons">
              <div v-if="configInputs == 0" class="btn-group">
                <label class="palavra" for="FotodoLadoSuperiorPreview"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  @change="previewFiles($event, 6)"
                  id="FotodoLadoSuperiorPreview"
                />

                <label
                  class="palavra"
                  @click="resetFile(6)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-success mb-4 shadow-lg">
          <!--  -->
          <div class="image-preview" v-if="imageData[7] != undefined">
            <img
              class="container"
              :src="`${imageData[7]}`"
              @click="clickPreview(imageData[7])"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <!--  -->

          <div class="card-body column">
            <p class="card-text">Foto da Plaqueta do sistema de refrigeração</p>
            <div class="icons">
              <div v-if="configInputs == 0" class="btn-group">
                <label
                  class="palavra"
                  for="FotodaPlaquetadosistemadeRefrigeraçãoPreview"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  @change="previewFiles($event, 7)"
                  id="FotodaPlaquetadosistemadeRefrigeraçãoPreview"
                />

                <label
                  class="palavra"
                  @click="resetFile(7)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
export default {
  components: { InputI1 },
  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  data() {
    return {
      imageData: [],

      FormDataImages: {
        FotoPlaquetadeIdentificacaodomoldeFile: [],
        IDdaCâmaraQuenteFile: [],
        FotodoLadoDireitoFile: [],
        FotodoLadoEsquerdoFile: [],
        FotodaPlacadoLadoMovelFile: [],
        FotodaPlacadoLadoFixoFile: [],
        FotodoLadoSuperiorFile: [],
        FotodaPlaquetadosistemadeRefrigeraçãoFile: [],
      },
    };
  },

  watch: {
    FormDataImages: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.commit("MutationImagesMoldeFechado", newValue);
      },
    },
  },
  methods: {
    clickPreview(base64) {
      this.$swal.fire({
        imageUrl: base64,
        imageWidth: 700,
        imageHeight: 400,
        imageAlt: "Custom image",
      });
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID) {
        this.imageData[0] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID}`;
        this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE != null) {
        this.imageData[1] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE}`;
        this.FormDataImages.IDdaCâmaraQuenteFile =
          dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO) {
        this.imageData[2] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO}`;
        this.FormDataImages.FotodoLadoDireitoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO) {
        this.imageData[3] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO}`;
        this.FormDataImages.FotodoLadoEsquerdoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL != null) {
        this.imageData[4] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL}`;
        this.FormDataImages.FotodaPlacadoLadoMovelFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO) {
        this.imageData[5] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO}`;
        this.FormDataImages.FotodaPlacadoLadoFixoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR) {
        this.imageData[6] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR}`;
        this.FormDataImages.FotodoLadoSuperiorFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF != null) {
        this.imageData[7] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF}`;
        this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF;
      }
    },

    previewFiles(event, position) {
      // Referência ao elemento de entrada DOM
      var input = event.target;
      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        //Identificando em qual contexto a imagem se encaixa
        switch (position) {
          case 0:
            this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile =
              input.files[0];
            break;
          case 1:
            this.FormDataImages.IDdaCâmaraQuenteFile = input.files[0];
            break;
          case 2:
            this.FormDataImages.FotodoLadoDireitoFile = input.files[0];
            break;
          case 3:
            this.FormDataImages.FotodoLadoEsquerdoFile = input.files[0];
            break;
          case 4:
            this.FormDataImages.FotodaPlacadoLadoMovelFile = input.files[0];
            break;
          case 5:
            this.FormDataImages.FotodaPlacadoLadoFixoFile = input.files[0];
            break;
          case 6:
            this.FormDataImages.FotodoLadoSuperiorFile = input.files[0];
            break;
          case 7:
            this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile =
              input.files[0];
            break;
        }
        // this.$emit("setFotosAbertEmb",this.FormDataImages)
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.imageData[position] = e.target.result;
        };
        // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
        reader.readAsDataURL(input.files[0]);

        //Acionar $Emit para enviar o objeto quando um File for adicionado

      }
    },

    resetFile(position) {
      this.imageData[position] = null;

      switch (position) {
        case 0:
          this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile = [];
          break;
        case 1:
          this.FormDataImages.IDdaCâmaraQuenteFile = [];
          break;
        case 2:
          this.FormDataImages.FotodoLadoDireitoFile = [];
          break;
        case 3:
          this.FormDataImages.FotodoLadoEsquerdoFile = [];
          break;
        case 4:
          this.FormDataImages.FotodaPlacadoLadoMovelFile = [];
          break;
        case 5:
          this.FormDataImages.FotodaPlacadoLadoFixoFile = [];
          break;
        case 6:
          this.FormDataImages.FotodoLadoSuperiorFile = [];
          break;
        case 7:
          this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile = [];
          break;
      }
    },
  },
};
</script>

<style scoped>
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-body .container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  width: 100%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.modal-body .container .gridPhoto {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.modal-body .container .gridPhoto .card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid var(--cinza);
  border-radius: 0.35rem;
}

.modal-body .container .gridPhoto .border-success {
  border-color: var(--green);
}

.modal-body .container .gridPhoto .mb-4 {
  margin-bottom: 1.5rem;
}

.modal-body .container .gridPhoto .shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.modal-body .container .gridPhoto .card img {
  vertical-align: middle;
  border-style: none;
}

.modal-body .container .gridPhoto .card .card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.modal-body .container .gridPhoto .card .card-body p {
  margin-top: 0;
  margin-bottom: 1rem;
}

.modal-body .container .gridPhoto .card .card-body .icons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body .container .gridPhoto .card .card-body .icons .btn-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.modal-body .container .gridPhoto .card .card-body .icons .btn-group .palavra {
  background-color: var(--blue);
  border-radius: 5px;
  color: var(--white);
  cursor: pointer;
  margin: 10px;
  padding: 6px 10px;
}

.modal-body .container .gridPhoto .card .card-body .icons .form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.modal-body .container .gridPhoto .card .card-body .icons .btn-group input {
  overflow: visible;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.modal-body
  .container
  .gridPhoto
  .card
  .card-body
  .icons
  .btn-group
  input[type="file"] {
  display: none;
}

.card-text {
  font-size: 0.8rem;
  font-weight: 700;
}

*,
::after,
::before {
  box-sizing: border-box;
}

@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1140px;
  }
}

.column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media (max-width: 425px) {
  .modal-body .container .gridPhoto {
    grid-template-columns: 1fr;
  }
  .modal-body .container,
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    padding: 0;
  }
}
</style>
